import { client } from '../../../../../common-utils/libraries/axios/axios';
import { buildUrl } from '@/common-utils/functions/restUtils';
import { AUTOCOMPLETE } from '../apiUrls';
import { excludeRepeatedValues } from '@/common-utils/functions/repeatedValues';

/**
 * @param root0
 * @param root0.features
 * @returns Mapped data object
 */
function mapResponseData({ features }) {
    const fHash = element => `${element.properties.city} : ${element.properties.citycode}`;
    const data = excludeRepeatedValues(features, fHash).map(element => {
        return { cityName: element.properties.city, cityCode: element.properties.citycode };
    }
    );

    return data;
}

const queryGetCity = (postCode, enabled) => {
    const query = { postcode: postCode, q: postCode, limit: 30 };

    return {
        queryKey: [AUTOCOMPLETE.DETAILS.queryKey, query],
        queryFn: async () => {
            const response = await client.get(buildUrl(AUTOCOMPLETE.DETAILS.url, query));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};


export default queryGetCity;